import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "category-heatmap-table",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "Cross-tab of per-row counts across labeled column groups, tinted by relative count, with a hover breakdown and totals.",
    domain: "reports",
    visual: "Heatmap table",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "table" },
  defaultLayoutClassName: "col-span-12",
};
